module.exports = __webpack_public_path__ + "img/poster.faba7bbe.png";